import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import GIF from "../../images/services-usa/web/web_banner_final.gif";

function Banner(props) {
  // Function to handle the scroll action
  const scrollToCaseStudies = () => {
    const caseBtnElement = document.getElementById("case_btn");
    if (caseBtnElement) {
      // Using `scrollIntoView` to scroll to the target element
      caseBtnElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div
      className="service_usa web_dev_service"
      style={{ backgroundColor: "#314252" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "0px" }}>
                Custom Web Development Services
              </h1>
              <span>Built-for-Experience, Scalable Websites</span>
              <p>
                Design and code custom, from-scratch web solutions that engage
                users and compel interactions at every step.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Request a Quote
              </Link>
              <button
                className="border_btn web_case_btn"
                aria-label="TekRevol Contact"
                onClick={scrollToCaseStudies}
              >
                Case Studies
              </button>
            </div>
            <div className="awards_web">
              <div className="awards_web_item">
                <StaticImage
                  src="../../images/services-usa/web/clutch.webp"
                  alt="tekrevol_web"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={127}
                  height={106}
                />
              </div>
              <div className="awards_web_item">
                <StaticImage
                  src="../../images/services-usa/web/horizon.webp"
                  alt="tekrevol_web"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={136}
                  height={117}
                />
              </div>
              <div className="awards_web_item">
                <StaticImage
                  src="../../images/services-usa/web/inc.webp"
                  alt="tekrevol_web"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={108}
                  height={107}
                />
              </div>
            </div>
          </Col>
          <Col xs={12} md={5} lg={6} xl={6} xxl={6} className="mt-auto">
            <div className="banner_desktop">
              <StaticImage
                src="../../images/services-usa/web/banner_desk_img.webp"
                alt="tekrevol_web"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={816}
                height={640}
              />
              <div className="banner_gif">
                <img src={GIF} alt="web development services" />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
